// extracted by mini-css-extract-plugin
export default {"mainButton":"EndCallButton_mainButton__nnbg2"};